import 'moment/min/locales';

import { CreateAlert, Icon, useForm } from 'modules';
// import echarts from 'echarts';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Routes } from '../../../AppRoutes';
import { PageHead } from '../../../components/page-head';
import { getLocaleKey } from '../../../languages';
import { AdminService } from '../../../services/admin';

export const TransactionDetail: FC = () => {
  const navigate = useNavigate();
  const params: any = useParams();
  const id = params?.id;

  const [dataTransactionDetail, setDataTransactionDetail] = useState<any>(null);
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);

  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    enableReinitialize: true,
    structure: [
      {
        name: 'phoneNumber',
        defaultValue: dataTransactionDetail?.phoneNumber,
        isDisabled: true,
      },
      {
        name: 'fullName',
        defaultValue: dataTransactionDetail?.fullName,
        isDisabled: true,
      },
      {
        name: 'email',
        defaultValue: dataTransactionDetail?.email,
        isDisabled: true,
      },
      {
        name: 'address',
        defaultValue: dataTransactionDetail?.address,
        isDisabled: true,
      },
    ],
    onSubmit: async (values) => {},
  });

  const handleOnClickToggleLock = () => {
    if (isButtonLoading === true) return;
    AdminService.handleLockUser(
      dataTransactionDetail?.id,
      dataTransactionDetail?.isActive === true ? true : false,
    )
      .then(async (res: any) => {
        await AdminService.getUserDetail(id).then((res) =>
          setDataTransactionDetail(res?.data),
        );
        CreateAlert({ message: 'Successfully!', type: 'success' });
      })
      .catch((err: any) => {
        CreateAlert({ message: err.message, type: 'danger' });
      })
      .finally(() => {
        setIsButtonLoading(false);
      });
  };

  useEffect(() => {
    AdminService.getTransactionDetail(id).then((res) =>
      setDataTransactionDetail(res?.data),
    );
  }, []);

  return (
    <div className='container-fluid transaction-detail'>
      <PageHead title='Transaction Detail' />
      <div className='transaction-detail-wrapper row'>
        <div className='col-12 primary-info__col'>
          <div className='primary-info'>
            <div className='primary-info__section'>
              <div className='row primary-info__section__row'>
                <div className='col-12'>
                  <div className='id-payment__label'>ID Payment</div>
                </div>
                <div className='col-12'>
                  <div className='id-payment__value'>
                    #{dataTransactionDetail?.id}
                  </div>
                </div>
              </div>
            </div>
            <div className='primary-info__section'>
              <div className='row primary-info__section__row'>
                <div className='col-3'>Transaction Code:</div>
                <div className='col-9'>
                  {dataTransactionDetail?.transactionCode ?? 'N/A'}
                </div>
              </div>
              <div className='row primary-info__section__row'>
                <div className='col-3'>Status:</div>
                <div className='col-9'>
                  <span className='status'>
                    <span className='status__icon'>
                      <Icon.ConfirmStatus />
                    </span>
                    <span className='status__label'>Success</span>
                  </span>
                </div>
              </div>
              <div className='row primary-info__section__row'>
                <div className='col-3'>Timestamp:</div>
                <div className='col-9'>
                  <span className='timestamp'>
                    <span className='timestamp__icon'>
                      <Icon.TimestampIcon />
                    </span>
                    <span className='timestamp__label'>
                      {dataTransactionDetail?.createdAt != null
                        ? moment(dataTransactionDetail?.createdAt)
                            .locale(getLocaleKey())
                            .format('L HH:mm:ss ([GMT]Z)')
                        : 'N/A'}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className='primary-info__section'>
              <div className='row primary-info__section__row'>
                <div className='col-3'>From:</div>
                <div className='col-9'>
                  <span
                    className={`phone-number ${dataTransactionDetail?.userFrom?.phoneNumber == null ? 'no-data' : ''}`}
                    onClick={() => {
                      if (dataTransactionDetail?.userFrom?.id == null) return;
                      navigate(
                        Routes.userDetail.renderPath(
                          dataTransactionDetail?.userFrom?.id,
                        ),
                      );
                    }}
                  >
                    {dataTransactionDetail?.userFrom?.phoneNumber ?? 'N/A'}
                  </span>
                </div>
              </div>
              <div className='row primary-info__section__row'>
                <div className='col-3'>To:</div>
                <div className='col-9'>
                  <span
                    className={`phone-number ${dataTransactionDetail?.userTo?.phoneNumber == null ? 'no-data' : ''}`}
                    onClick={() => {
                      if (dataTransactionDetail?.userTo?.id == null) return;
                      navigate(
                        Routes.userDetail.renderPath(
                          dataTransactionDetail?.userTo?.id,
                        ),
                      );
                    }}
                  >
                    {dataTransactionDetail?.userTo?.phoneNumber ?? 'N/A'}
                  </span>
                </div>
              </div>
              <div className='row primary-info__section__row'>
                <div className='col-3'>Amount:</div>
                <div className='col-9'>
                  {dataTransactionDetail?.value != null
                    ? new Intl.NumberFormat('en').format(
                        dataTransactionDetail?.value,
                      )
                    : 'N/A'}
                </div>
              </div>
              <div className='row primary-info__section__row'>
                <div className='col-3'>Transaction Type:</div>
                <div className='col-9'>
                  {dataTransactionDetail?.transactionTypeName ?? 'N/A'}
                </div>
              </div>
            </div>
            <div className='primary-info__section'>
              <div className='row primary-info__section__row'>
                <div className='col-3'>Description:</div>
                <div className='col-9'>
                  <div className='description'>
                    {(dataTransactionDetail?.description ?? '') !== ''
                      ? dataTransactionDetail?.description
                      : 'N/A'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
